import { createClient } from "contentful";

const useContentful = () => {
  const client = createClient({
    space: "z8y0vjmsaydo",
    accessToken: "8ZjFlh-V6gdm3c55ZluTxGqX5S08NjdDRBSMq7H4T_4",
    host: "cdn.contentful.com"
  });
//   const client = createClient({
//     space: "kp7895evg2nd",
//     accessToken: "eieMViKbcQqp9ejVR437kMmqZ7SagfqOOTKWZGfESRs",
//     host: "cdn.contentful.com"
//   });

  const getOrders = async () => {
    try {
      const entries = await client.getEntries({
        content_type: "product",
        // select: "fields"
      });

     
      const sanitizedEntries = entries.items.map((item) => {
        const avatar = item.fields.productName;
        return {
          ...item.fields,
          avatar
        };
      });

      console.log("entries",sanitizedEntries)

      return sanitizedEntries;
    } catch (error) {
      console.log(`Error fetching authors ${error}`);
    }
  };
  const getAuthors = async () => {
    try {
      const entries = await client.getEntries({
        content_type: "product",
        // select: "fields"
      });

     
      const sanitizedEntries = entries.items.map((item) => {
        const avatar = item.fields.productName;
        return {
          ...item.fields,
          avatar
        };
      });

      console.log("entries",sanitizedEntries)

      return sanitizedEntries;
    } catch (error) {
      console.log(`Error fetching authors ${error}`);
    }
  };
  const getSizes = async () => {
    try {
      const entries = await client.getEntries({
        content_type: "size",
        // select: "fields"
      });

     
      const sanitizedEntries = entries.items.map((item) => {
        const avatar = item.fields.productName;
        return {
          ...item.fields,
          avatar
        };
      });

      console.log("size",sanitizedEntries)

      return sanitizedEntries;
    } catch (error) {
      console.log(`Error fetching size ${error}`);
    }
  };

  const getColor = async () => {
    try {
      const entries = await client.getEntries({
        content_type: "colour",
        // select: "fields"
      });

     
      const sanitizedEntries = entries.items.map((item) => {
        const avatar = item.fields.productName;
        return {
          ...item.fields,
          avatar
        };
      });

      console.log("colour",sanitizedEntries)

      return sanitizedEntries;
    } catch (error) {
      console.log(`Error fetching colour ${error}`);
    }
  };


  const getPosters = async () => {
    try {
      const entries = await client.getEntries({
        content_type: "posters",
        // select: "fields"
      });

      console.log("entries",entries)
      const sanitizedEntries = entries.items.map((item) => {
        const avatar = item.fields.productName;
        return {
          ...item.fields,
          avatar
        };
      });

      return sanitizedEntries;
    } catch (error) {
      console.log(`Error fetching authors ${error}`);
    }
  };
  const getPartners = async () => {
    try {
      const entries = await client.getEntries({
        content_type: "partners",
        // select: "fields"
      });

      console.log("entries",entries)
      const sanitizedEntries = entries.items.map((item) => {
        const avatar = item.fields.productName;
        return {
          ...item.fields,
          avatar
        };
      });

      return sanitizedEntries;
    } catch (error) {
      console.log(`Error fetching authors ${error}`);
    }
  };

  return { getAuthors,getPosters,getPartners,getColor,getSizes,getOrders };
};

export default useContentful;

// import { createClient } from "contentful";

// const useContentful = () => {
//   const client = createClient({
//     space: "f980zcpmf0m0",
//     accessToken: "5l6J_HtfcFdShJuUXrmKwDBR0rejdhvgRgEHqv2zb6U",
//     host: "preview.contentful.com"
//   });

//   const getAuthors = async () => {
//     try {
//       const entries = await client.getEntries({
//         content_type: "author",
//         select: "fields"
//       });

//       const sanitizedEntries = entries.items.map((item) => {
//         const avatar = item.fields.avatar.fields;
//         return {
//           ...item.fields,
//           avatar
//         };
//       });

//       return sanitizedEntries;
//     } catch (error) {
//       console.log(`Error fetching authors ${error}`);
//     }
//   };

//   return { getAuthors };
// };

// export default useContentful;